export const regionalCountries = {
  ecuador: {
    id: "ecuador",
    name: "Ecuador",
    lat: -1.8312,
    lng: -78.1834,
    status: "Operación consolidada",
    pending: false,
    description:
      "Operación consolidada dentro de la red regional de soluciones de pago de CAPTEC.",
  },
  colombia: {
    id: "colombia",
    name: "Colombia",
    lat: 4.5709,
    lng: -74.2973,
    status: "Operación regional activa",
    pending: false,
    description:
      "Operación regional activa para acompañar proyectos de pagos en Colombia y la expansión de CAPTEC en Latinoamérica.",
  },
  panama: {
    id: "panama",
    name: "Panamá",
    lat: 8.538,
    lng: -80.7821,
    status: "Presencia regional",
    pending: true,
    description:
      "Presencia regional y desarrollo comercial para acompañar oportunidades de medios de pago.",
  },
  mexico: {
    id: "mexico",
    name: "México",
    lat: 23.6345,
    lng: -102.5528,
    status: "Presencia regional",
    pending: true,
    description:
      "Presencia regional y desarrollo comercial dentro de la estrategia latinoamericana de CAPTEC.",
  },
  honduras: {
    id: "honduras",
    name: "Honduras",
    lat: 15.1999,
    lng: -86.2419,
    status: "Presencia regional",
    pending: true,
    description:
      "Presencia regional y desarrollo comercial para acompañar nuevos proyectos de pagos.",
  },
};

// Selection changes size/outline, never the operational meaning of the color.
export const regionColors = { active: "#34d399", regional: "#8b5cf6" };
export const countryColor = (country) => country.pending ? regionColors.regional : regionColors.active;
